import { defineTemplate } from 'src/utils';
import { LOGO_VS_LOGO_BASE_URL } from './urls';
import { LOGO_VS_LOGO_LEAGUES } from './data/leagues';
import { logoVsLogo1920x1080 } from './layouts/LogoVsLogo-1920x1080';

export const disneyESPNLogoVsLogo = defineTemplate({
  mode: 'wysiwyg',
  id: 'espn/logo-vs-logo',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Logo VS Logo',
  templateFamily: 'logo-vs-logo',
  thumbnail: {
    url: `${LOGO_VS_LOGO_BASE_URL}/thumbnail.png`,
    optimizedUrl: `${LOGO_VS_LOGO_BASE_URL}/optimized/thumbnail.png`,
    aspectRatio: 'horizontal'
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'league',
      label: 'Liga',
      type: 'visual-search-single',
      placeholder: 'Buscar liga...',
      slotLabel: 'Liga',
      required: true,
      options: LOGO_VS_LOGO_LEAGUES.map(l => ({
        value: l.value,
        label: l.label,
        imageUrl: l.logo.src,
        disabled: l.disabled
      }))
    },
    {
      key: 'teams',
      label: 'Equipos',
      type: 'visual-search',
      placeholder: 'Buscar equipo...',
      slotLabels: ['Local', 'Visitante'],
      required: true,
      options: []
    },
    {
      key: 'local-color',
      label: 'Color del local',
      type: 'visual-search-single',
      placeholder: 'Elegí el color del local',
      slotLabel: 'Color local',
      required: true,
      options: []
    },
    {
      key: 'visitor-color',
      label: 'Color del visitante',
      type: 'visual-search-single',
      placeholder: 'Elegí el color del visitante',
      slotLabel: 'Color visitante',
      required: true,
      options: []
    },
    {
      key: 'matchday',
      label: 'Fecha / Jornada',
      type: 'input',
      placeholder: 'Ej: 33',
      required: false
    },
    // Internal fields — populated by applyFieldLogic, consumed by bindings.
    { key: 'league-logo-data', label: '', type: 'internal', required: false, hiddenFromDetail: true },
    { key: 'local-shield-data', label: '', type: 'internal', required: false, hiddenFromDetail: true },
    { key: 'visitor-shield-data', label: '', type: 'internal', required: false, hiddenFromDetail: true }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1920x1080',
        label: '1920 × 1080',
        canvasWidth: 1920,
        canvasHeight: 1080,
        type: 'image',
        aspectRatioCode: 'L178',
        layout: logoVsLogo1920x1080
      }
    ],
    fieldBindings: [
      { kind: 'simple', fieldKey: 'league-logo-data', pieceId: 'league-logo', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'local-shield-data', pieceId: 'local-shield', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'visitor-shield-data', pieceId: 'visitor-shield', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'local-color', pieceId: 'local-bg', bindingType: 'fill-color' },
      { kind: 'simple', fieldKey: 'visitor-color', pieceId: 'visitor-bg', bindingType: 'fill-color' }
    ]
  }
});
